import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-item-cmb-eligibility-personal-apply.component.scss';
import * as $ from 'jquery';
var FormItemCmbEligibilityPersonalApply = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemCmbEligibilityPersonalApply, _super);
    function FormItemCmbEligibilityPersonalApply(element) {
        return _super.call(this, element) || this;
    }
    FormItemCmbEligibilityPersonalApply.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.form = this.element.querySelector('form');
        this.selectTitle = this.element.querySelector('.js-title');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.hidLeadId = this.form.querySelector('input[name=leadId]');
        this.hidProduct = this.form.querySelector('input[name=product]');
        this.buttonRetry = this.element.querySelector('.js-retry-button');
        this.buttonClose = this.element.querySelector('.js-close-button');
        this.radioHaveFinancialAdvisor = Array.from(this.element.querySelectorAll('input[name=financial-advisor]'));
        this.checkFirstRadio();
        var storage = localStorage.getItem('winApplicationID');
        if (storage) {
            this.applicationStorage = JSON.parse(storage);
        }
    };
    FormItemCmbEligibilityPersonalApply.prototype.bindEvents = function () {
        var _this = this;
        this.selectTitle.addEventListener('change', function (event) {
            var element = event.target;
            _this.addMoreTitle(element);
        });
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            console.log('Offshore Button Click', event);
            var formFields = _this.form.querySelectorAll('input, select, textarea');
            var validation = _this.validationService.validateEnterprise(formFields);
            console.log('Offshore Validation', validation);
            if (validation.valid) {
                _this.actionForm(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'), _this.element.querySelector('.form__error--container'));
            }
        }); });
        $(document).on('click', '.js-apply-now-modal-open', function (event) {
            var element = event.target;
            var parentAttribute = "";
            if (element.closest('.product-offering-exchange__button')) {
                parentAttribute = element.closest('.product-offering-exchange__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.comparison-exchange__product__button')) {
                parentAttribute = element.closest('.comparison-exchange__product__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.detailed-product-card-exchange__buttons-js')) {
                parentAttribute = element.closest('.detailed-product-card-exchange__buttons-js').getAttribute('data-buttonclass');
            }
            if (parentAttribute === 'Apply') {
                var type = $(element).attr('data-productname');
                var leadid = $(element).attr('data-leadid');
                var modalId = $(element).attr('data-modal');
                if (type) {
                    _this.hidProduct.value = type;
                }
                if (leadid) {
                    _this.hidLeadId.value = leadid;
                }
                if (modalId) {
                    _this.hidCallMeBackModalId = modalId;
                }
                // APPLICATION ID
                var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
                var valueEligibilityFormID = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-modal');
                var valueProductName = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-productname');
                var valueFormName = "apply";
                var windowLocation = window.location.toString();
                if (windowLocation.includes("/bank/")) {
                    valueFormName += " | wealth bank accounts | " + valueProductName;
                }
                if (windowLocation.includes("/borrow/")) {
                    valueFormName += " | wealth bank accounts | " + valueProductName;
                }
                if (windowLocation.includes("/grow/")) {
                    valueFormName += " | wealth savings | " + valueProductName;
                }
                if (windowLocation.includes("/structured-products")) {
                    valueFormName += " | wealth bank accounts | " + valueProductName;
                }
                _this.form.setAttribute('data-frmcontainer', valueFormName);
                if (_this.form.querySelector('a.js-apply-now__button')) {
                    var buttonSubmit = _this.form.querySelector('a.js-apply-now__button');
                    buttonSubmit.setAttribute('data-intent', 'Transactional');
                    buttonSubmit.setAttribute('data-scope', 'formitemcmbeligibilitypersonal');
                    buttonSubmit.setAttribute('data-id', 'link_content');
                    buttonSubmit.setAttribute('data-text', valueFormName + ' | submit button click');
                }
                if (_this.form.querySelector('a.js-retry-button')) {
                    var buttonRetry = _this.form.querySelector('a.js-retry-button');
                    buttonRetry.setAttribute('data-intent', 'Transactional');
                    buttonRetry.setAttribute('data-scope', 'formitemcmbeligibilitypersonal');
                    buttonRetry.setAttribute('data-id', 'link_content');
                    buttonRetry.setAttribute('data-text', valueFormName + ' | retry button click');
                }
                if (_this.form.querySelector('a.js-close-button')) {
                    var buttonClose = _this.form.querySelector('a.js-close-button');
                    buttonClose.setAttribute('data-intent', 'Transactional');
                    buttonClose.setAttribute('data-scope', 'formitemcmbeligibilitypersonal');
                    buttonClose.setAttribute('data-id', 'link_content');
                    buttonClose.setAttribute('data-text', valueFormName + ' | close button click');
                }
            }
        });
        this.radioHaveFinancialAdvisor.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            var financialAdvisorCompanyName = _this.form.querySelector('input[name=financial-advisor-company-name]');
            var financialAdvisorName = _this.form.querySelector('input[name=financial-advisor-name]');
            var financialAdvisorContact = _this.form.querySelector('input[name=financial-advisor-contact]');
            var containerFinancialAdvisorCompanyName = financialAdvisorCompanyName.closest('.form__group');
            var containerFinancialAdvisorName = financialAdvisorName.closest('.form__group');
            var containerFinancialAdvisorContact = financialAdvisorContact.closest('.form__group');
            if (element.value === 'No') {
                financialAdvisorCompanyName.classList.remove('form__input--required');
                financialAdvisorName.classList.remove('form__input--required');
                financialAdvisorContact.classList.remove('form__input--required');
                containerFinancialAdvisorCompanyName.classList.add('d-none');
                containerFinancialAdvisorName.classList.add('d-none');
                containerFinancialAdvisorContact.classList.add('d-none');
            }
            else {
                financialAdvisorCompanyName.classList.add('form__input--required');
                financialAdvisorName.classList.add('form__input--required');
                financialAdvisorContact.classList.add('form__input--required');
                containerFinancialAdvisorCompanyName.classList.remove('d-none');
                containerFinancialAdvisorName.classList.remove('d-none');
                containerFinancialAdvisorContact.classList.remove('d-none');
            }
        }); });
        this.buttonRetry.addEventListener('click', function (event) {
            _this.resetForm();
        });
        this.buttonClose.addEventListener('click', function (event) {
            var element = event.target;
            var modal = element.closest('.modal');
            var modalClose = modal.querySelector('.js-apply-now-modal-close');
            modalClose.click();
            setTimeout(function () {
                _this.resetForm();
            }, 1000);
        });
    };
    FormItemCmbEligibilityPersonalApply.prototype.addMoreTitle = function (element) {
        if (element) {
            if (element.value == 'Other') {
                var parentParent = element.closest('.form__fields--container');
                var parent_1 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-other-title-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = 'Other Title';
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-other-title');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', 'Enter your title');
                newInput.setAttribute('maxlength', '4');
                newInput.setAttribute('name', 'other-title');
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_1.nextSibling);
            }
            else {
                var parentParent = element.closest('.form__fields--container');
                var oldInput = this.element.querySelector('.js-other-title-container');
                parentParent.removeChild(oldInput);
            }
        }
    };
    FormItemCmbEligibilityPersonalApply.prototype.checkFirstRadio = function () {
        this.radioHaveFinancialAdvisor.forEach(function (item) {
            item.checked = item.value === 'Yes';
        });
    };
    FormItemCmbEligibilityPersonalApply.prototype.resetForm = function () {
        if (this.form) {
            var hidLeadId = this.form.querySelector('input[name=leadId]');
            var hidProduct = this.form.querySelector('input[name=product]');
            var hidDeliveryEmail = this.form.querySelector('input[name=deliveryEmail]');
            var gRecaptchaResponse = undefined;
            if (this.form.querySelector('textarea[name=g-recaptcha-response]')) {
                gRecaptchaResponse = this.form.querySelector('textarea[name=g-recaptcha-response]');
            }
            var valueLeadId = hidLeadId.value;
            var valueProduct = hidProduct.value;
            var valueDeliveryEmail = hidDeliveryEmail.value;
            var valueRecaptchaResponse = "";
            if (gRecaptchaResponse) {
                valueRecaptchaResponse = gRecaptchaResponse.value;
            }
            this.form.reset();
            hidLeadId.value = valueLeadId;
            hidProduct.value = valueProduct;
            hidDeliveryEmail.value = valueDeliveryEmail;
            if (this.form.querySelector('textarea[name=g-recaptcha-response]')) {
                gRecaptchaResponse.value = valueRecaptchaResponse;
            }
            var financialAdvisorCompanyName = this.form.querySelector('input[name=financial-advisor-company-name]');
            var financialAdvisorName = this.form.querySelector('input[name=financial-advisor-name]');
            var financialAdvisorContact = this.form.querySelector('input[name=financial-advisor-contact]');
            var containerFinancialAdvisorCompanyName = financialAdvisorCompanyName.closest('.form__group');
            var containerFinancialAdvisorName = financialAdvisorName.closest('.form__group');
            var containerFinancialAdvisorContact = financialAdvisorContact.closest('.form__group');
            financialAdvisorCompanyName.classList.add('form__input--required');
            financialAdvisorName.classList.add('form__input--required');
            financialAdvisorContact.classList.add('form__input--required');
            containerFinancialAdvisorCompanyName.classList.remove('d-none');
            containerFinancialAdvisorName.classList.remove('d-none');
            containerFinancialAdvisorContact.classList.remove('d-none');
            this.checkFirstRadio();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            var formContainerError = this.element.querySelector('.form__error--container');
            formContainerLoader.classList.remove('active');
            formContainerLoader.classList.remove('hidden');
            formContainerFields.classList.remove('active');
            formContainerFields.classList.remove('hidden');
            formContainerThankyou.classList.remove('active');
            formContainerThankyou.classList.remove('hidden');
            formContainerError.classList.remove('active');
            formContainerError.classList.remove('hidden');
            formContainerFields.classList.add('active');
        }
    };
    FormItemCmbEligibilityPersonalApply.prototype.actionForm = function (form, loader, thankyou, error) {
        // fields
        var productType = this.form.querySelector('input[name=product]');
        var leadID = this.form.querySelector('input[name=leadId]');
        var deliveryEmail = this.form.querySelector('input[name=deliveryEmail]');
        var title = this.form.querySelector('select[name=title]');
        var titleOther = form.querySelector('input[name=other-title]');
        var firstName = form.querySelector('input[name=first-name]');
        var middleName = form.querySelector('input[name=middle-name]');
        var surname = form.querySelector('input[name=surname');
        var dailingCode = form.querySelector('select[name=dailing-code');
        var telephone = form.querySelector('input[name=telephone');
        var email = form.querySelector('input[name=email');
        var confirmEmail = form.querySelector('input[name=confirm-email');
        var haveFinancialAdvisor = form.querySelector('input[name=financial-advisor]:checked');
        var financialAdvisorCompanyName = form.querySelector('input[name=financial-advisor-company-name');
        var financialAdvisorName = form.querySelector('input[name=financial-advisor-name');
        var financialAdvisorContact = form.querySelector('input[name=financial-advisor-contact');
        var deliveryEmail = form.querySelector('input[name=deliveryEmail');
        var siteKey = form.querySelector('div.g-recaptcha').getAttribute('data-sitekey');
        var gRecaptchaResponse = form.querySelector('textarea[name=g-recaptcha-response]');
        var pageUrl = window.location.href;
        var applicationID = this.checkEligibility.applicationID;
        var productID = this.checkEligibility.applicationProductID;
        // containers
        var formContainerLoader = form.querySelector('.form__loader--container');
        var formContainerFields = form.querySelector('.form__fields--container');
        var formContainerThankyou = form.querySelector('.form__thankyou--container');
        var formContainerError = form.querySelector('.form__error--container');
        // check confirm email address
        if (email && confirmEmail) {
            if (email.value !== confirmEmail.value) {
                var confirmEmailContainer = confirmEmail.closest('.form__group');
                confirmEmailContainer.classList.add('form__group--error');
                return false;
            }
        }
        // check recaptchas
        if (!gRecaptchaResponse) {
            var formRecaptchaField = this.form.querySelector('.form-item-generic-form__recaptcha');
            if (formRecaptchaField.querySelector('.form__group--error_message')) {
                var errorMessage = formRecaptchaField.querySelector('.form__group--error_message');
                formRecaptchaField.removeChild(errorMessage);
            }
            var docfragment = document.createDocumentFragment();
            docfragment.appendChild(document.createRange().createContextualFragment('<div class="form__group--error_message">Please click on the reCAPTCHA box</div>'));
            formRecaptchaField.appendChild(docfragment);
            return false;
        }
        // show loader
        formContainerFields.classList.remove('active');
        formContainerFields.classList.add('hidden');
        formContainerLoader.classList.add('active');
        // postdata
        var postData = '';
        postData += 'operation=submitandverify&';
        postData += 'category=individual&';
        if (title) {
            if (titleOther) {
                postData += 'title=' + titleOther.value + '&';
            }
            else {
                postData += 'title=' + title.value + '&';
            }
        }
        if (firstName) {
            postData += 'firstName=' + firstName.value + '&';
        }
        if (middleName) {
            postData += 'middleNames=' + middleName.value + '&';
        }
        if (surname) {
            postData += 'surname=' + surname.value + '&';
        }
        if (dailingCode) {
            postData += 'dialCode=' + dailingCode.value + '&';
        }
        if (telephone) {
            postData += 'telNo=' + telephone.value + '&';
        }
        if (email) {
            postData += 'emailAddress=' + email.value + '&';
        }
        if (haveFinancialAdvisor) {
            postData += 'ifaReferral=' + haveFinancialAdvisor.value + '&';
            if (haveFinancialAdvisor.value === 'Yes') {
                if (financialAdvisorCompanyName) {
                    postData += 'ifaCompany=' + financialAdvisorCompanyName.value + '&';
                }
                if (financialAdvisorName) {
                    postData += 'ifaName=' + financialAdvisorName.value + '&';
                }
                if (financialAdvisorContact) {
                    postData += 'ifaContactDetails=' + financialAdvisorContact.value + '&';
                }
            }
        }
        if (productType) {
            postData += 'productName=' + productType.value + '&';
            postData += 'comments=Interested in a ' + productType.value + '&';
        }
        if (leadID) {
            postData += 'leadID=' + leadID.value + '&';
        }
        if (this.hidCallMeBackModalId) {
            postData += 'callmebackFormId=' + this.hidCallMeBackModalId + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        if (applicationID) {
            postData += 'appID=' + applicationID + '&';
        }
        if (productID) {
            postData += 'productID=' + productID + '&';
        }
        if (siteKey) {
            postData += 'siteKey=' + siteKey + '&';
        }
        if (gRecaptchaResponse) {
            postData += 'g-recaptcha-response=' + gRecaptchaResponse.value + '&';
        }
        if (deliveryEmail) {
            postData += 'deliveryEmail=' + deliveryEmail.value + '&';
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // data
            var json = response.data;
            if (json.result === 'success') {
                // success
                analyticsService.dtmFormComplete('complete', '');
                formContainerLoader.classList.remove('active');
                formContainerThankyou.classList.add('active');
            }
            else {
                // failed
                analyticsService.dtmFormComplete('complete', '');
                formContainerLoader.classList.remove('active');
                formContainerError.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            formContainerLoader.classList.remove('active');
            formContainerError.classList.add('active');
        });
    };
    return FormItemCmbEligibilityPersonalApply;
}(Base));
export { FormItemCmbEligibilityPersonalApply };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-cmb-eligibility-personal-apply/form-item-cmb-eligibility-personal-apply.component.ts
// module id = 795
// module chunks = 0